import {
  SET_ERROR,
  SET_LEAD,
  SET_LEAD_WIZARD,
  SET_LEAD_WIZARD_ERROR,
  SET_CUR_MODE,
} from './mutation-types';

export default {
  [SET_ERROR](state, error) {
    state.error = error;
  },
  [SET_LEAD](state, lead) {
    state.questionnaireLead = lead || {};
  },
  [SET_LEAD_WIZARD](state, leadWizard) {
    state.leadWizard = leadWizard || {};
  },
  [SET_LEAD_WIZARD_ERROR](state, error) {
    state.leadWizardError = error;
  },
  [SET_CUR_MODE](state, mode) {
    state.mode = mode;
  },
};
